/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import ErrorStackParser from 'error-stack-parser';

/**
 * @ngdoc service
 * @name ErrorStackParser
 * @description
 *
 *     Wrapper for error-stack-parser dependency.
 */
angular.module('avi/deps').factory('ErrorStackParser', () => ErrorStackParser);
